/**
 * Returns the spaces that were on the event when edit opened but are no
 * longer in the form. Only spaces with an `inviteeId` count — a space added
 * during this session has no invitee on the server, so removing it again
 * needs no API call.
 */
export function getRemovedSpaceInvitees(initialSpaces, formSpaces) {
    if (!(initialSpaces === null || initialSpaces === void 0 ? void 0 : initialSpaces.length))
        return [];
    var formSpaceIds = new Set((formSpaces !== null && formSpaces !== void 0 ? formSpaces : []).map(function (space) { return space.id; }));
    return initialSpaces.filter(function (space) {
        return !!space.inviteeId && !formSpaceIds.has(space.id);
    });
}
